export enum InspectionAcceptableFileType {
    JPG = 0,
    PNG = 1,
    JPEG = 2,
    JPE = 3,
    GIF = 4,
    BMP = 5,
    TIF = 6,
    TIFF = 7,
    XLSX = 8,
    XLS = 9,
    DOC = 10,
    DOCX = 11,
    PDF = 12,
    PPTX = 13,
    PPT = 14,
}
